export default function FormGeneralSettings({ formData, setFormData }) {
  const updateField = (key, value) => {
    setFormData({ ...formData, [key]: value });
  };

  return (
    <div className="bg-white shadow p-4 rounded-lg space-y-4">
      <h2 className="text-xl font-semibold">Thông tin chung</h2>

      <input
        type="text"
        placeholder="Tiêu đề form"
        value={formData.title}
        onChange={(e) => updateField("title", e.target.value)}
        className="border rounded p-2 w-full"
      />

      <input
        type="text"
        placeholder="Alias (slug)"
        value={formData.alias}
        onChange={(e) => updateField("alias", e.target.value)}
        className="border rounded p-2 w-full"
      />

      <textarea
        placeholder="Mô tả"
        value={formData.description}
        onChange={(e) => updateField("description", e.target.value)}
        className="border rounded p-2 w-full"
      />

      <div className="flex gap-4">
        <input
          type="datetime-local"
          value={formData.timestart}
          onChange={(e) => updateField("timestart", e.target.value)}
          className="border rounded p-2"
        />
        <input
          type="datetime-local"
          value={formData.timeend}
          onChange={(e) => updateField("timeend", e.target.value)}
          className="border rounded p-2"
        />
      </div>

      <select
        value={formData.status}
        onChange={(e) => updateField("status", e.target.value)}
        className="border rounded p-2"
      >
        <option value={1}>Kích hoạt</option>
        <option value={0}>Không kích hoạt</option>
      </select>
    </div>
  );
}
